import {
  Input,SimpleChanges,OnChanges,
  Component,
  EventEmitter,
  Output,
  OnInit
} from '@angular/core';
import {SessionTimeVM} from "../../../models/SessionTimeVM.model";

@Component({
  selector: 'rw-simple-date-picker',  // <home></home>
  styles: [require('./simple-date-picker.component.css')],
  template: require('./simple-date-picker.component.html')
})
export class SimpleDatePickerComponent implements OnInit,OnChanges {

  @Input() public selectedDateStr:string;
  @Output()selectedDateStrChanged:EventEmitter<string> = new EventEmitter();
  public yearList = [];
  public monthList = [];
  public dayList = [];
  public selectedYear :number;
  public selectedMonth :number;
  public selectedDay :number;

  constructor() {
  }

  public ngOnInit() {

    this.makeYearList();
    this.makeMonthList();
    this.makeDayList()

  }

  ngOnChanges(changes:SimpleChanges):void {
    let parent = this;
  }

  onSelectedMonthChanged() {
    this.makeDayList();
    this.updateDateStr();
  }
  onSelectedYearChanged() {
    this.updateDateStr();
  }
  onSelectedDayChanged() {
    this.updateDateStr();
  }

  updateDateStr(){
    if(this.selectedYear&&this.selectedMonth&&this.selectedDay)
    {
      let monthStr = this.selectedMonth.toString();
      if(monthStr.length ==1)
      {
        monthStr = "0"+monthStr;
      }
      let dayStr = this.selectedDay.toString();
      if(dayStr.length ==1)
      {
        dayStr = "0"+dayStr;
      }

      this.selectedDateStr = this.selectedYear+"/"+monthStr+"/"+dayStr;
      // this.isValid = true;

    }
    else
    {
      this.selectedDateStr = "";

      // this.isValid = false;
    }
    this.selectedDateStrChanged.emit(this.selectedDateStr);
  }

  makeYearList()
  {
    this.yearList = [];
     let year = 1300;
     while(year<1410)
     {
        this.yearList.push(year);
        year++;
     }
  }

  makeMonthList(){
    this.monthList = [1,2,3,4,5,6,7,8,9,10,11,12];
  }

  makeDayList()
  {
    this.dayList=[];

      let day = 1;
      while (day<=31)
      {
        this.dayList.push(day);
        day++;
      }
      // if(this.selectedMonth && this.selectedMonth<7)
      // {
      //     this.dayList.push(31);
      // }
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/shared/simple-date-picker/simple-date-picker.component.ts